import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		themes: {
			light: {
				headerColor1: '#090C15',
				cardColor1: '#F6F6F6',
				iconColor1: '#4B83FC',
				iconColor2: '#B4B4B4',
				btnColor1: '#D0EBF0',
				aboutColor1: '#D6A776',
				m_aboutColor1: '#093981',
			},
		},
	},
})
